import { PlusCircle } from "@phosphor-icons/react";
import { useState } from "react";

import { AddProxy } from "common/components/Proxy";
import { Button } from "common/components/ui/Button";

export default function AddProxyButton({ size }: { size: "sm" | "md" }) {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <>
      <Button
        leftIcon={<PlusCircle weight="fill" />}
        size={size}
        onClick={() => {
          setIsDialogOpen(true);
        }}
      >
        Add proxy
      </Button>
      <AddProxy isOpen={isDialogOpen} setIsOpen={setIsDialogOpen} />
    </>
  );
}
